import { Radio } from 'components/common';

interface LanguageProps {
  selectedLanguage: string;
  setSelectedLanguage: (lang: string) => void;
}

const LanguageSetting = ({ selectedLanguage, setSelectedLanguage }: LanguageProps) => {
  const extendedResourceMap = {
    auto: brsc.set_automatically,
    ...resource_map,
  };

  const filteredLanguageList = Object.entries(extendedResourceMap)
    .map(([lang, locale]) => ({
      lang: lang as string,
      locale: locale as string,
    }))
    .filter((language) => language.lang !== selectedLanguage);

  return (
    <div className="flex h-full flex-col">
      <div className="sticky top-0 flex items-center gap-3 pt-5 pb-4 bg-base-bg-strong w-full">
        <Radio name="languageGroup" value={selectedLanguage} isChecked={true} readOnly />
        <span className="typography-headline-sm text-base-txt-primary">{extendedResourceMap[selectedLanguage]}</span>
      </div>
      <div className="h-full flex-1 overflow-y-auto">
        {filteredLanguageList.map((item) => (
          <li key={item.lang} className="list-none">
            <label className="flex items-center gap-3 py-5">
              <Radio name="languageGroup" value={item.lang} isChecked={selectedLanguage === item.lang} onChange={() => setSelectedLanguage(item.lang)} />
              <span className="typography-body-sm text-base-txt-secondary">{item.locale}</span>
            </label>
          </li>
        ))}
      </div>
    </div>
  );
};
export default LanguageSetting;
